module.exports = "<fn-input label=\"$ctrl.label\" description=\"$ctrl.description\"><div class=\"fn-text\" ng-bind=\"$ctrl.model\"></div></fn-input>";